import { render } from "./AddAddendum.vue?vue&type=template&id=2865922d"
import script from "./AddAddendum.ts?vue&type=script&lang=js&external"
export * from "./AddAddendum.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__